import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuditTrailSearchService {

  constructor() { }

  // Observable string sources
    private searchAuditTrailData = new Subject<string>();
  
    // Observable string streams
    public searchData$ = this.searchAuditTrailData.asObservable();
  
    // Service message commands
    public getSearchedData(text: string): void {
      this.searchAuditTrailData.next(text);
    }

}
